<template>
    <tr v-if="ticket">
        <td class="hide-cell">
            <i class="fa fa-ticket" aria-hidden="true"></i>
        </td>

        <td data-label="Ticket details" class="tickets">{{ticket.details}}</td>

        <td data-label="Early Bird Cost" data-th="Early Bird Cost" v-if="hasEarlyBird">
            <div :style="!earlyBirdValid ? {'text-decoration': 'line-through', 'color': 'gray'} :{}">
                {{ticket.cost_a | currency('£')}}
            </div>
        </td>

        <td data-label="Cost" data-th="Cost" v-if="hasPaidTickets">
            <div :style="earlyBirdValid ? {'text-decoration': 'line-through', 'color': 'gray'} :{}">
                {{(ticket.cost_b) | currency('£')}}
            </div>
        </td>

        <td data-label="Vat Amount" data-th="Vat Amount" v-if="vatable">
            {{calcVatAmount(ticket) | currency('£')}}
        </td>

        <td v-if="vatable" data-th="Total Remaining" data-label="Total Remaining">
            {{calcPricePlusVat(ticket) | currency('£')}}
        </td>

        <td data-label="Tickets Remaining" data-th="Tickets Remaining" v-if="event.show_tickets_remaining">
            <strong>{{ticket.tickets_remaining}}</strong>
        </td>

        <td data-label="Ticket Date & Time" data-th="Ticket Date & Time" class="ticket-date-time">
          <span v-html="ticketTimeAndDate"></span>
        </td> 

        <td data-label="Number of tickets" v-if="ticket.tickets_remaining > 0">
            <select v-if="ticket.group_amount > 1" class="form-control input-lg" :disabled="disabled" style="width: 100px !important" v-model="ticket.quantity_tickets" @change="setTicket(ticket)">
                <option v-for="n in minTicketNumberRange()" :selected="n == ticket.quantity_tickets" :value="n">
                    {{displayTicketAmount(n, ticket.group_amount) }}
                </option>
            </select>

            <select v-if="ticket.group_amount == 1" class="form-control input-lg" :disabled="disabled" style="width: 100px !important" v-model="ticket.quantity_tickets" @change="setTicket(ticket)">
                <option v-for="n in minTicketNumberRange()" :selected="n == ticket.quantity_tickets" :value="n">
                    {{n}}
                </option>
            </select>
        </td>

        <td class="textalignment" v-if="ticket.tickets_remaining == 0">
            <span class="label label-soldout">Sold Out</span>
        </td>
    </tr>
</template>

<script>
import moment from "moment";
import EventBus from "../../events/event-bus";
import ticketMixins from "./tickets-mixin";
import {mapGetters} from 'vuex';

export default {
  props: ["event", "ticket", "disabled"],

  mixins: [ticketMixins],

  created() {
    if (this.event && this.event.datetime_eb) {
      this.discountValid = moment(this.event.datetime_eb).isAfter(new Date());
    }

    if (!this.ticket.quantity_tickets) {
      this.ticket.quantity_tickets = 0;
    }

    if (this.ticket.tickets_remaining == null) {
      this.ticket.tickets_remaining = this.ticket.ticket_no;
    }

    if(this.ticket.start_time){
      var sdt = new Date(this.ticket.start_time);
      this.startTime = moment(sdt).format("DD/MM/YYYY - HH:mm");
    }

    if(this.ticket.end_time){
      var edt = new Date(this.ticket.end_time);
      this.endTime = moment(edt).format("DD/MM/YYYY - HH:mm");
    }
  },

  data() {
    return {
      vatRate: window.vatRate,
      ticketsSelected: 0,
      discountValid: false,
      startTime: null,
      endTime: null
    };
  },

  computed: {
    ...mapGetters({
      hasPaidTickets: 'getChargeable'
    }),

    ticketTimeAndDate(){
      if(this.startTime && this.endTime){
        return `${this.startTime} <br/> ${this.endTime}`
      } else if (this.startTime && !this.endTime) {
        return this.startTime;
      } else {
        return "";
      }
    }
  },

  methods: {
    displayTicketAmount(n, group_amount) {
      if (n == 0) {
        return n;
      } else {
        return n + " x " + group_amount;
      }
    },

    getVatRate(ticket) {
      if (ticket.vat_rate) {
        this.vatRate = ticket.vat_rate.rate;
      }
      return this.vatRate;
    },

    calcVatAmount(ticket) {
      var vatRate = this.getVatRate(ticket) / 100;
      //TODO why is cost_a etc a string??
      if (this.discountValid) {
        return +ticket.cost_a * vatRate;
      } else {
        return +ticket.cost_b * vatRate;
      }
    },

    calcPricePlusVat(ticket) {
      if (this.discountValid) {
        return +ticket.cost_a + this.calcVatAmount(ticket);
      } else {
        return +ticket.cost_b + this.calcVatAmount(ticket);
      }
    },

    minTicketNumberRange() {
      var total = Math.min(
        this.ticket.tickets_remaining,
        this.ticket.max_allowed
      );

      var rangeArray = [];
      for (var i = 0; i < total + 1; i++) {
        rangeArray.push(i);
      }
      return rangeArray;
    },

    setTicket(ticket) {
      ticket.from_basic = true;
      EventBus.$emit("setTicket", ticket);
      this.ticketsSelected = ticket.quantity_tickets;
    },

    minTicketNumberRangeChild(ticket) {
      var total = Math.min(ticket.tickets_remaining, ticket.max_allowed);

      var rangeArray = [];
      for (var i = 0; i < total + 1; i++) {
        rangeArray.push(i);
      }
      return rangeArray;
    }
  }
};
</script>

<style scoped>
.ticketround {
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  border-width: 10px;
  background: #ff9500;
  color: white;
  padding: 6px;
  font-size: 20px;
}

.sub {
  background-color: white !important;
  color: black;
}
</style>
